<template>
    <vue-basic-alert :duration="300" :closeIn="2000" ref="alert" />
    <div class="register-container">
        <div class="register-form-container">
            <form id="addBankAccForm" @submit="handleSubmit" novalidate autocomplete="off">
                <div class="heading">
                    <h3>Print form K Notice</h3>
                </div>
                <div ref="pdfContent" class="print-container">
    
         <div class="row">
         <div class="col-sm-12">
            <table style="width: 100%; font-size: large; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse; " >
                <thead>
                    <tr>
                        <th colspan="3" style="width: 33%;  text-align: center; vertical-align:middle; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;" >
                            වරිපනම් ගෙවීම ගැන වගකවයුත්තේ අයිතිකරු නම් කරුණාකර ඔහුට මේ නිවේදනය භාර දෙන්න<br>
                          <span style="font-size: small;">  சொந்தக்காரர் வரிப்பணத்திற்கு பாத்திரவாளியாக இருந்தால் தயவு செய்து அவருக்கு அனுப்பவும்</span><br>
                            PLEASE PASS ON TO OWNER IF HE IS RESPOSIBLE FOR THIS
                        </th>
                     
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td style="font-size: 10px;width: 33%;  text-align: justify;padding-left: 2px;padding-right: 2px; vertical-align: text-top; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;" >

වරිපනම් ගෙවීම පිළිබඳ කොන්දේසි හා උපදෙස්<br>
1. තක්සේරුවට කෙරෙන විරෝධතා<br>
මෙම තක්සේරුව ගැන එකඟ නොවේ නම් නීති ප්‍රකාර දෙන ලද දැන්වීම් බාරදුන් දින සිට මාසයක් ඇතුලත දී තම විරෝධතාවය සියලු කාරනා අඩංගු ලියවිල්ලකින් ප්‍රාදේශීය සභා කාර්යාලයට දැන්විය යුතුය.
<br>යොමුව ; ලේකම්,<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;තුම්පනේ ප්‍රාදේශීය සභාව,<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ගලගෙදර<br><br>
2. වරිපනම් සම්පුර්ණයෙන් හෝ සමාන වාරික හතරකින් ගෙවීම.<br>
(i) ඔබ විසින් කර ඇති කිසියම් විරුද්ධතාවයක් වෙතොත්, ඒවා නිරාකරණය කර ගන්නා තෙක්, දැන්වීමේ ප්‍රකාර නියමිත දිනයන්හි හෝ ඊට පෙර වරිපනම් ගෙවිය යුතුය. එසේ නැතහොත් වරෙන්තුවක් නිකුත් කිරීමේ වියදම් සදහා ඔබ අමතර ගාස්තුවක් ගෙවිය යුතුය.
<br>(ii) කිසියම් වාර්ෂික වරිපනම් බදු මුදලක් ඒ වර්ෂයේ ජනවාරි 31 වෙනි දිනට හෝ එදිනට පෙර ගෙවනු ලැබුවහොත් ඒ බදු මුදලින් සියයට දහයක වට්ටමක්ද, එසේ නැතහොත් ඒ වරිපනම් බදු මුදල කොටස් වශයෙන් ගෙවිය යුතු වන අවස්ථාවක එසේ ගෙවිය යුතු චරිපනම් බදු මුදලෙහි කොටස ගෙවිය යුතුව ඇත්තේ සම්කිසි කාලසීමාවක් සදහා ද ඒ කාලසීමාවේ පළමුවෙනි මාසය ඇතුලතදී ගෙවනු ලැබුවහොත් ඒ වරිපනම් මුදලින් සියයට පහක වට්ටමක්ද ලබා ගැනීමට ඔබට අයිතියක් ඇත.
<br>(iii) වරෙන්තුවක් නිකුත් කිරීමේ වියදම් සදහා මුඩු ඉඩම් සහ වාසස්ථාන වෙනුවෙන් ගෙවනු ලැබීය යුතු වරිපනම් බදු ප්‍රමාණයෙන් සියයට පහළොවක් ද අනෙකුත් දේපල වෙනුවෙන් ගෙවිය යුතු වරිපනම් බදු ප්‍රමානයෙන් සියයට විස්සක් ද ආදී වශයෙන් අය කිරීමක් කරනු ලැබේ.
<br><br>3. නියමිත දිනට පෙර ඔබ මෙම වරිපම් මුදල නොගෙවුව හොත් ඔබගේ චංචල හෝ නිශ්චල දේපළ හෝ එම දේපළෙන් ලැබෙන කුලී මුදල් සහ ලාභය අත්පත් කරගෙන විකිනීම අදාළ හිඟ මුදල් පියවාගැනීමට 1987 අංක 15 දරණ ප්‍රාදේශීය සභා පනතේ සඳහන් විධිවිධාන අනුව කටයුතු කරනු ලැබේ.
<br><br>4. පදිංචි වී නැති ගොඩනැගිලි වෙනුවෙන් වරිපනම් බදු ලිහිල් කිරීම.
ලී බඩු අඩංගු ගොඩනැගිල්ලක් හැර අන් කිසියම් ගොඩනැගිල්ලක් පදිංචි වී නැති නම් එම ගොඩනැගිල්ල හිස්ව තිබෙන කාල සීමාව සදහා ගෙවිය යුතු වරිපනම් ලිහිල් කිරීම ගැන සලකා බැලීමට පුළුවන.
ඉහත දැක්වෙන අවස්ථාවේදී එම ගොඩනැගිල්ල පදිංචි වී නැති බව ලිඛිත දැනුම්දීමක් සභාවට ලැබෙන දින සිට වරිපනම් ලිහිල් කිරීම ආරම්භ වන අතර. එස නැවත පදිංචියට ගත් දිනයෙන් අවසන් වෙයි. එසේ වනුයේ එම නැවත පදිංචියට ගැනීම සිදුවූ දින සිට දින තුනක් ඇතුලත ඒ බව සභාවට දැනුම් දී තිබේ නම් පමණි. එකී නියමිත කාල සීමාව ඇතුළත එම නැවත පදිංචි වීම පිළිබද දැනුම් දීමක් සභාවට නොලැබුනි නම් එම නැවත පදිංචි වූ දිනයට එක් මාසයකට පෙර දිනයකින් වරිපනම් ලිහිල් කිරීම අවසන් වේ.
<br><br>5. මෙම දැන්වීම්
<br>(i) තක්සේරු කටයුතු සදහා පමණක් වලංගු වේ.
<br>(ii) විධිමත් ගොඩනැගිලි සැලසුම් අනුමත නොකළ පරිශ්‍ර සදහා මෙසින් පනවා ඇති වරිපනම් බදු මුදල ගෙවීමෙන් පමණක් එම පරිශ්‍රය විධිමත් වීමක් හෝ නිත්‍යනුකූල වීමක් සිදු නොවේ
                        </td>
                       
                        <td style="font-size: 7px;width: 33%;  text-align: justify;padding-left: 2px;padding-right: 2px; vertical-align: text-top; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                      
வரியிறுத்தலுக்கான நிபந்தனைகளும் அறிவுறுத்தல்களும்,<br>
1.வரி மதிப்பீட்டுக்கான ஆட்சேபனை:<br>
இந்த வரிமதிப்பீடு சம்பந்தமாக ஏதாவது குறைபாடுகள் இருப்பின் இச் சொத்து வரிமதிப்பீடு செய்யப்பட்டதற்கான சட்ட ரீதியான அறிவித்தல் உங்களுக்கு கிடைக்கப்பெற்ற திகதியிலிருந்து ஒரு மாத காலத்திற்குள் உங்களது ஆட்சேபனைக்கான காரணங்களை எழுத்து மூலம் பிரதேசசபை காரியாலயத்துக்கு சமர்ப்பித்தல் வேண்டும்.
<br>அனுப்ப:வேண்டிய முகவரி<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;தும்ப்பனே பிரதேச சபை,<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;களகேதர<br><br>
2. வரிப்பணத்தை மொத்தமாக அல்லது நான்கு காலாண்டு தவணைப் பணமாக செலுத்துதல், 
<br>(i) தங்களினால் ஏதாவது வரிப்பணம் தொடர்பாக ஆட்சேபனை செய்யப்பட்டிருப்பினும் அதற்கு தீர்வு காணும்வரை அறிவித்தலில் குறிப்பிட்ட திகதிக்கு அல்லது அதற்கு முன்பாகவே வரிப்பணம் செலுத்தப்படுதல் வேண்டும் இல்லாவிடின் மேலதிகமாக தண்டப்பணம் செலுத்த வேண்டி நேரிடும். 
<br>(ii) ஒவ்வொரு ஆண்டிலும் வரிப்பணக் கொடுப்பனவிற்கான முழுத்தொகயையும் ஜனவரி மாதம் 31ம் திகதி அன்றோ அல்லது அதற்கு முன்போ செலுத்தப்படுமிடத்து அம்முழுத்தொகையின் 10% வீதக் கழிவினைப் பெறலாம் தவனை முறையில் செலுத்தப்பட வேண்டிய தொகை அந்த காலத் தவணையின் முதல் மாதத்திற்குள் செலுத்தபடுமாயின் 5% வீதக் கழிவைப் பெறலாம்.
<br>(iii) வெற்றுக் காணிகளுக்கும்.வதிவிடச் சொத்துக்களுக்கும் எழுத்தாணை ஒன்றுவிடுக்கப்படுமிடத்து செலவுத் தொகையாக 15% வீதம் மேலதிகமாக அறவிடப்படும் .இது தவிர்ந்த ஏனைய சொத்துகளுக்கு செலவத்தொகை 20% வீதமாகும்.
<br><br>3. குடியமர்த்தப்படாத கட்டிடங்களிற்கான வரி விலக்கு
நியமித்த காலவரையுள் வரிப்பணத்தைச் செலுத்தத் தவறினால் பிரதேசசபைகள் சட்டத்தின்படி அசையும் அல்லது அசையாத ஆதனங்களையோ அல்லது ஆதனத்திலிருந்து பெறப்படும் வாடகை.இலாபம் என்பவற்றையோ கைப்பற்றி விற்று வரிப்பண நிலுவையை மீட்க நடவடிக்கை எடுக்கப்படும்.
<br><br>4. தளபாடங்கள் போடப்பட்ட கட்டிடத்தை தவிர்ந்த ஏனைய ஏதாவது கட்டிடங்கள் பாவிக்கப்படாமலோ .குடியமர்த்தப்படாமலோ இருக்குமாயின் அக்காலத்திற்கு வரி அறவிடுவதிலிருந்து விலக்கு அளிக்கப்படும்.இத்தகைய சந்தர்ப்பங்களில் அத்தகைய கட்டிடங்கள் வெற்றிடமாகும் தினத்தைப்பற்றி இச்சபைக்கு எழுத்து மூலம் அறிவிக்கப்படுதல் வேண்டும்.இத்தகைய அறிவித்தல் கிடைக்கப்பெறும் தினத்திலிருந்து மீண்டும் பாவனைக்கு உட்படுத்தப்படும் காலம் வரை வரி விலக்கு
அளிக்கப்படும்...கட்டிடங்கள் பற்றிய விபரங்களை மீண்டும் பாவனைக்கு உட்படுத்திய நாளில் இருந்து 3 தினங்களுக்குள் எமக்கு அறிவித்தல் வேண்டும்.அவ்வாறன அறிவித்தல் கிடைக்கப் பெறாதவிடத்து அச் சொத்து பாவனைக்கு உட்படுத்தப்பட்ட தினத்திலிருந்து ஒரு மாதத்துக்கு முன்னதாக பாவனைக்கு உட்படுத்தப்பட்டதாக கணித்து வரி அறவீடு செய்யப்படும்
<br><br>5. இவ்வறிவித்தல்
<br>(i) வரி மதிப்பீட்டு நடவடிக்கைகளுக்கு ம்ட்டும் செல்லுபடியாகும்
<br>(ii) கட்டிட அனுமதிப் பத்திரமின்றி கட்டப்பட்ட ஏதாவது ஒரு கட்டிடம் ஒன்றுக்கு வரிப்பணம் செலுத்துவதாவது அக்கட்டிடம் உரிய அனுமதியுடன் கட்டப்பட்டது என்பதை சான்று படுத்தாது  
                        
                        </td>
                        <td style="font-size: 10px;width: 33%;  text-align: justify;padding-left: 2px;padding-right: 2px; vertical-align:text-top; border-width: 1px ; border-style: solid; border-color : #130f40; border-collapse: collapse;">
                      <b> CONDITIONSAND INSTRUCTIONS TO PAYMENT OF ASSESSMENT RATES</b><br><br>
1. Objections to Assessments.<br>
If you are aggrieved by this assessment you may lodge your objections at Pradeshiya Sabha office WITHIN ONE MONTH FROM THE DATE OF SERVICE OF THE STATUTORY NOTICE upon the premises assessed. Such objections must be in writing and must specify the grounds upon which the objection is made.
<br> To: Secretary,<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Thumpane Pradeshiya Sabha,<br>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Galagedara.<br><br>
2. Payments of Rates I full or in four equal installments.<br>
(i) The Rates should be paid as stated in the notice on or before the dates specified therein until the settlement of the objection if any lodged by you. Otherwise you will be liable for the surcharge on the issue of a warrant.<br>
(ii) You will be entitled to a discount of ten percent of the amount of a any annual rates payable under this section if such rates are paid on or before the thirty first day of January of that year or where such rates are payable in installments, a discount of five percent of installment of rate due if such amount is paid within the first one month of period for which the installment rates are due.<br>
(iii) You will be charged for cost on the issue of a warrant at fifteen percent on the amount of rates due on bare lands and residential properties, and twenty percent or the amount of rates due on properties other than bare land and residential properties.<br><br>
3. If you fail to make the payment of rates in time action will be taken to seize and sell the movable or immovable property or the rents and profits from the property as per the provisions of the Pradeshiya Sabha Act No 15 of 1987 in order to defray the amount recoverable.
4. Remission of Rates in respect of un-occupied buildings.<br><br>
If any building, other than a building containing furniture, is or remains untenanted, remission of the rates payable in respect of such building could be considered for the period during which the building is, or remains untenanted.
In which case remission will commence on the day on which the council receives a written notice of such building being untenanted and terminate on the date on which it is re-occupied provided notice of such re-occupation is given to the council within three days of such re-occupation, if a notice of re-occupation is not received within the said stipulated period, remission will terminate on a date one month prior to the date of re-occupation.<br><br>
5. This Notice.<br>
(i) It is valid only for Assessment purposes.<br>
(ii) The payment of assessment rates on any building constructed without an approved building permit in any event does not make such constructions authorized
                        </td>
                    </tr>
                   
                    
                </tbody>
               
                </table>
            </div>
        </div>
       
    </div> 
      
</form>
    
 <button @click="printpdf" class="btn"> Print Notice</button>
   
        </div>
    </div>
 
</template>

<script>
// import axios from "axios";
import VueBasicAlert from 'vue-basic-alert';
// import html2pdf from 'html2pdf.js';
//import { ref } from 'vue'
export default {

    name: "Kform",

    data() {
        return {
      
            matchHead: undefined,
            ratehead : '',
            nic:"",
            sabha: "",
          
            userLevel:"",
       
        }
    },

    created() {
        this.getDataFromSessionStorage()
       
      
    },
   
    methods: {
        async getDataFromSessionStorage(){
            const data = JSON.parse(sessionStorage.getItem('userData'))
            if(data){
                            this.nic = data.nic 
                            this.sabha = data.sabha
                            this.userLevel =data.userLevel
                        }
    
        },

        printpdf() {
            const prtHtml = this.$refs.pdfContent.innerHTML;
            const WinPrint = window.open('', '', 'width=1000,height=700');

            WinPrint.document.write(`
            <html>
                <head>
                <style>
                    @page {
                    size: A4 landscape;
                    margin: 15mm;
                    }

                    body {
                    font-family: Arial, sans-serif;
                    }

                
                
                </style>
                </head>
                <body>
                ${prtHtml}
                </body>
            </html>
            `);

            WinPrint.document.close();
            WinPrint.focus();
            WinPrint.print();

            setTimeout(() => {
            WinPrint.close();
            //   this.$router.push('/invoice');
            }, 500);
        },

    },
    components: {
        VueBasicAlert
    }
}
</script>

<style scoped>
.print-container {
  padding: 20px;
  background: white;
  font-family: 'Arial', sans-serif;
}

.property-block {
  margin-bottom: 20px;
  page-break-after: always;
}

button {
  margin-bottom: 20px;
  padding: 10px 20px;
  font-weight: bold;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
/* new */
.ttable {
     
     width: 100%;
     border-width:2px;
     border-color : #101011;
     /* border-style: solid; */
     font-size: 1.2rem;
     /* background-color :white; */
     /* padding-left: 3rem; */
      /* height: 3rem; */
 }
 th  {
     text-align: center;
}
.ttable, th, td {
border: 1px solid;
text-align: left;
height: 45px;
}

.ttable, tr {
height: 15%;
}


.register-container {
    padding: 2rem 2%;
    min-height: 72.3vh;
}

.register-container .register-form-container {
    background: #fff;

}

.register-container .register-form-container form {
    position: relative;
    left: 50%;
    transform: translate(-50%, 0%);
    /* max-width: 70rem; */
    width: 100%;
    box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.05);
    border: 0.1rem solid rgba(0, 0, 0, 0.2);
    padding: 2rem;
    border-radius: 0.5rem;
    animation: fadeUp 0.4s linear;
}



.btn {
    margin: 1rem 0;
    width: 20%;
    text-align: center;
    background-color:#4e0707 ;
font-size: 12px;
    
}



</style>